import UserLiquidationsTable from 'src/components/LiquidationsTable/UserLiquidationsTable/UserLiquidationsTable';
import PortfolioHistoryLiquidationsTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryLiquidationsTable/PortfolioHistoryLiquidationsTableControls';

export default function PortfolioHistoryLiquidationsTable() {
	return (
		<div>
			<PortfolioHistoryLiquidationsTableControls />
			<UserLiquidationsTable />
		</div>
	);
}
